import { render } from "./S1PrizeModal.vue?vue&type=template&id=7a1a13ce"
import script from "./S1PrizeModal.vue?vue&type=script&lang=js"
export * from "./S1PrizeModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__